// extracted by mini-css-extract-plugin
export default {"NavBtn":"Navbar_NavBtn__tPyrf"};